<bn-loading-overlay></bn-loading-overlay>
<div class="container"  *ngIf="model">
    <form [formGroup]="formIrregularidade" class="form">

        <div class="row">
            <div class="col">
                <h3>Irregularidade de Operação Garantida <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
            </div>            
            <div class="col-auto">
                <button type="button" class="btn " 
                  [ngClass]="formIrregularidade.pristine ? 'btn-primary' : 'btn-danger' " 
                  (click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
                </button>
                  
                <button *ngIf="modoEdicao" type="button" class="btn btn-primary" 
                  [disabled]="formIrregularidade.pristine || !formIrregularidade.valid" 
                  (click)="salvar ()">Salvar
                </button>
      
                <button *ngIf="permissaoEdicao && !modoEdicao" type="button" class="btn btn-primary" 
                    (click)="habilitarEdicao ()">Editar
                </button>            
            </div>

        </div>

        <div class="row">
            <div class="col-md-6 bn-form-group">
                <label class="form-label"><b>Agente Financeiro:</b></label>
                <select class="form-select" name="idAgenteFinanceiro" formControlName="idAgenteFinanceiro" >
                    <option [ngValue]=agente.id *ngFor="let agente of agentesFinanceiros">
                        {{ agente.nome }}
                    </option>
                </select>
            </div> 
                
            <div class="bn-form-group col-md-3" >
                <label class="form-label" for="dataInicio"><b>Inicio da Irregularidade</b></label>
                <bn-datepicker formControlName="dataInicio"  name="dataInicio" idInput="dataInicio"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3" >
                <label class="form-label" for="dataFim"><b>Encerramento da Irregularidade</b></label>
                <bn-datepicker formControlName="dataFim" name="dataFim" idInput="dataFim"></bn-datepicker>
            </div>

        </div>

        <div class="row">
            <div class="col-md-3 bn-form-group">
                <label class="form-label"><b>Tipo Operação/Sistema:</b></label>
                <select class="form-select" name="classeOperacao" formControlName="classeOperacao">
                    <option *ngFor="let classeOperacao of classesOperacao" 
                        [ngValue]="classeOperacao.codigo">{{ classeOperacao.nome }}
                    </option>
                </select>  
            </div>
            <div class="col-md-5 bn-form-group">
                <label class="form-label"><b>Id externo operação:</b></label>
                <input class="form-control" name="idOperacaoExterno" formControlName="idOperacaoExterno">
            </div>

            <div class="col-md-4 bn-form-group">
                <label class="form-label"><b>Contrato:</b></label>
                <input class="form-control" name="contratoRepasse" formControlName="contratoRepasse">
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-12 bn-form-group">
                <label class="form-label"><b>Motivo</b></label>
                <input class="form-control" name="motivo" formControlName="motivo">
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 bn-form-group">
                <label class="form-label"><b>Mensagem</b></label>
                <textarea class="form-control" formControlName="mensagem" rows="3"></textarea>
            </div>
        </div>
                
        <div class="row">
            <div class="col-md-3 bn-form-group">
                <label class="form-label"><b>Data de envio</b></label>
                <input type="text" class="form-control" name="dataEnvio" formControlName="dataEnvio">
            </div>

            <div class="col-md-9">
                <label class="form-label"><b>Enviado por</b></label>
                <input type="text" class="form-control" name="nomeUsuarioEnvio" formControlName="nomeUsuarioEnvio">
            </div>
        </div>
    </form>
    
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>